import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AvatarModule } from 'primeng/avatar'
import { DividerModule } from 'primeng/divider'
import { TooltipModule } from 'primeng/tooltip'
import { CardModule } from 'primeng/card'
import { ContactViewModel } from '../../../../core/models/intervention-edit.model'
import { AffairContactModel } from '../../../../core/models/affair-contact.model'

@Component({
  selector: 'app-intervention-contacts',
  standalone: true,
  imports: [
    CommonModule,
    AvatarModule,
    DividerModule,
    TooltipModule,
    CardModule,
  ],
  templateUrl: './intervention-contacts.component.html',
  styleUrls: ['./intervention-contacts.component.scss'],
})
export class InterventionContactsComponent {
  @Input() contacts: ContactViewModel[] = []
  @Input() worksSupervisor: ContactViewModel | null = null
  @Input() affairsContacts: AffairContactModel[] = []

  /**
   * Génère les initiales à partir du nom complet
   */
  getInitials(fullName: string): string {
    if (!fullName) return '??'

    const names = fullName.split(' ')
    if (names.length >= 2) {
      return (names[0].charAt(0) + names[1].charAt(0)).toUpperCase()
    }
    return fullName.substring(0, 2).toUpperCase()
  }

  /**
   * Génère une couleur aléatoire mais cohérente basée sur le nom
   */
  getAvatarColor(fullName: string): string {
    if (!fullName) return '#6366F1'

    // Génération d'une couleur basée sur le nom pour être cohérente
    let hash = 0
    for (let i = 0; i < fullName.length; i++) {
      hash = fullName.charCodeAt(i) + ((hash << 5) - hash)
    }

    // Convertir en couleur hexadécimale
    const hue = Math.abs(hash % 360)
    return `hsl(${hue}, 70%, 60%)`
  }
}
